// extracted by mini-css-extract-plugin
export default {"wrapper":"Second_wrapper__Yv+Uy","bg":"Second_bg__NO5Y8","content":"Second_content__8yOlH","title":"Second_title__Lvo0U","desc":"Second_desc__KZnjm","button":"Second_button__dRxqJ"};